import { jsx as e, jsxs as d, Fragment as l } from "react/jsx-runtime";
import { Chains as c } from "porto";
import { useMemo as m } from "react";
import { ChainIcon as o } from "../ChainIcon/ChainIcon.js";
import { css as t } from "../apps/ui/styled-system/css/css.js";
function a({ chainIds: n }) {
  const [r, ...s] = m(
    () => n.map(
      (i) => c.all.find((h) => h.id === i) || {
        id: i,
        name: `Unknown (${i})`
      }
    ).reverse(),
    [n.map]
  );
  return r && /* @__PURE__ */ e(
    "div",
    {
      className: t({
        alignItems: "center",
        display: "flex",
        fontSize: 14,
        fontWeight: 500,
        gap: 6
      }),
      children: s.length === 0 ? /* @__PURE__ */ d(l, { children: [
        /* @__PURE__ */ e(o, { chainId: r.id, size: 18 }),
        r.name
      ] }) : /* @__PURE__ */ d(l, { children: [
        /* @__PURE__ */ e(o.Stack, { border: !1, size: 18, children: s.reverse().map((i) => /* @__PURE__ */ e(o, { chainId: i.id }, i.id)) }),
        /* @__PURE__ */ e(a.Arrow, {}),
        /* @__PURE__ */ e(o, { chainId: r.id, size: 18 })
      ] })
    }
  );
}
((n) => {
  function r() {
    return /* @__PURE__ */ e(
      "div",
      {
        className: t({
          alignItems: "center",
          backgroundColor: "var(--background-color-th_badge)",
          borderRadius: "50%",
          display: "flex",
          height: 16,
          justifyContent: "center",
          width: 16
        }),
        title: "to",
        children: /* @__PURE__ */ e(
          "svg",
          {
            className: t({
              color: "var(--text-color-th_badge)"
            }),
            fill: "none",
            height: 16,
            viewBox: "0 0 16 16",
            width: 16,
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ e(
              "path",
              {
                d: "M8 4.5 11.5 8m0 0L8 11.5M11.5 8h-7",
                stroke: "#838383",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "1.5"
              }
            )
          }
        )
      }
    );
  }
  n.Arrow = r;
})(a || (a = {}));
export {
  a as ChainsPath
};
//# sourceMappingURL=ChainsPath.js.map
